import { addColumnHeader } from "../helpers";
import Decimal from "decimal.js";
export const aggregateColumnData = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  Object.entries(rule.aggregateMappings).forEach(([key, value]) => {
    addColumnHeader(outputSheet, outputColumns, value);
  });

  if (rule.calculateSumByDate && rule.useOutputOf) {
    getColumnAggregateByDate(
      worksheet,
      outputSheet,
      rule,
      fileSettings,
      rules,
      inputColumns,
    );
  } else {
    getColumnAggregate(worksheet, outputSheet, rule, fileSettings, rules);
  }
};

// Reduces a list of Decimal values down to the single result for the
// chosen action. Count doesn't need numeric values at all, so it's
// handled before the empty-list short-circuit that the other actions rely on.
const computeAggregate = (values, action) => {
  if (action === "count") {
    return new Decimal(values.length);
  }
  if (values.length === 0) {
    return new Decimal(0);
  }
  switch (action) {
    case "average":
      return values
        .reduce((acc, val) => acc.plus(val), new Decimal(0))
        .dividedBy(values.length);
    case "max":
      return values.reduce((acc, val) => (val.greaterThan(acc) ? val : acc));
    case "min":
      return values.reduce((acc, val) => (val.lessThan(acc) ? val : acc));
    case "sum":
    default:
      return values.reduce((acc, val) => acc.plus(val), new Decimal(0));
  }
};

const getColumnAggregateByDate = (
  worksheet,
  outputSheet,
  rule,
  fileSettings,
  rules,
  inputColumns,
) => {
  const headerRow = fileSettings.headerRow;
  const outputRowIndices = {}; // Track output row indices per column

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );
  const dateColumn = inputColumns.find(
    (clmObj) => clmObj.inColChr === useOutputOf.inputColumn,
  );

  const dateGroups = {};

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > headerRow) {
      const dateValue = row.getCell(dateColumn.inColChr).value;

      if (dateValue) {
        if (!dateGroups[dateValue]) {
          dateGroups[dateValue] = {};
        }

        Object.entries(rule.aggregateMappings).forEach(
          ([inputCol, outputCol]) => {
            const cellValue = parseFloat(row.getCell(inputCol).value);
            if (!isNaN(cellValue)) {
              if (!dateGroups[dateValue][outputCol]) {
                dateGroups[dateValue][outputCol] = [];
              }
              dateGroups[dateValue][outputCol].push(new Decimal(cellValue));
            }
          },
        );
      }
    }
  });

  // Write the aggregated results to the output sheet
  Object.entries(dateGroups).forEach(([date, aggregates]) => {
    Object.entries(aggregates).forEach(([outputCol, values]) => {
      if (!(outputCol in outputRowIndices)) {
        outputRowIndices[outputCol] = 2; // Start at row 2 for each output column
      }
      const result = computeAggregate(values, rule.selectedAction);
      outputSheet.getCell(`${outputCol}${outputRowIndices[outputCol]}`).value =
        result.toNumber();
      outputRowIndices[outputCol]++;
    });
  });
  return; // Exit after processing date groups
};

const getColumnAggregate = (worksheet, outputSheet, rule, fileSettings, rules) => {
  const headerRow = fileSettings.headerRow;
  const outputRowIndices = {}; // Track output row indices per column

  Object.entries(rule.aggregateMappings).forEach(([inputCol, outputCol]) => {
    const values = [];

    if (!(outputCol in outputRowIndices)) {
      outputRowIndices[outputCol] = 2; // Start at row 2 for each output column
    }

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > headerRow) {
        const cellValue = parseFloat(row.getCell(inputCol).value);
        if (!isNaN(cellValue)) {
          values.push(new Decimal(cellValue));
        }
      }
    });

    const result = computeAggregate(values, rule.selectedAction);
    outputSheet.getCell(`${outputCol}${outputRowIndices[outputCol]}`).value =
      result.toNumber();
    outputRowIndices[outputCol]++;
  });
};
